module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAAHeq0ewAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAM5JREFUeNpi/N/CAALyTEBCAYgfAAQQA1DkIYgnBxBAjEDWIyBDFqQAIIBAHHkgfQikmAWsEALAamHAHiCAQMpAxtxnQAWKTFC96OAg2Cqo5Y+hGMSWBwggRqjTpgNxEhDPA+JMkOqPQJzBUP2fDUwzMHwCCfKhmcvLhMUyBpDgZzSxzzDtMxlaGX+BaSAfIMBgtnsA8SqQeVhMA5kUBsQ7mKC6tqMorP6P4iCo/HSQ4gQG4kASSPECDOFWRmyKF4AUpwOxJxZfIrsZJJ8OAEeILcHnkg+/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/workspace/tanhao.png
// module id = B19h
// module chunks = 2